import { apiURL } from "../../../../config/default";
import axios from "axios";
export const UseFetch = async (url) => {
  try {
    const res = await axios.get(`${apiURL}${url}`);
    return res;
  } catch (err) {
    console.log(err);
  }
};
